import { useEffect, useState } from "react";
import { Youtube, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const YT_COLOR = "#FF4444";

const YoutubeVideos = () => {
  const { lang, t } = useLanguage();
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/youtube/videos`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (active && d) setVideos(d.videos || []);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!videos || videos.length === 0) return null;

  return (
    <section className="border-t border-white/10 px-6 py-24 md:px-12" data-testid="youtube-section">
      <div className="mx-auto max-w-7xl">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="mb-4 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em]" style={{ color: YT_COLOR }}>
              <Youtube className="h-4 w-4" />
              {t.youtube.kicker}
            </p>
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl" data-testid="youtube-title">
              {t.youtube.title}
            </h2>
          </div>
          <a
            href="https://www.youtube.com/@fabiocomelli"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="youtube-channel-link"
            className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 font-mono text-xs uppercase tracking-widest transition-colors duration-300 hover:border-neon hover:text-neon"
          >
            {t.youtube.more}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {videos.slice(0, 3).map((v, i) => (
            <Reveal key={v.video_id} delay={i * 0.1}>
              <a
                href={v.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`youtube-video-${i}`}
                className="group block border border-white/10 bg-surface transition-transform duration-300 hover:-translate-y-1.5"
              >
                <div className="overflow-hidden">
                  {v.thumbnail && (
                    <img src={v.thumbnail} alt={v.title} loading="lazy" className="aspect-video w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  )}
                </div>
                <div className="p-5">
                  <p className="line-clamp-2 font-display text-base font-bold leading-snug">{v.title}</p>
                  <p className="mt-2 font-mono text-[10px] uppercase tracking-widest text-muted2">
                    {new Date(v.published_at).toLocaleDateString(lang === "it" ? "it-IT" : "en-GB", { day: "numeric", month: "short", year: "numeric" })}
                  </p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default YoutubeVideos;
